export default {"src":"/_next/static/media/figs.7c97ae2b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};